import React, {Component} from 'react';
import styled from "styled-components";
import PropTypes from 'prop-types';

const ContentWrapper = styled.div`
    margin: 0;
`;

const CancelButton = styled.button`
    background-color: #cccccc;
    color: black;
    border-radius: 0.25rem;
    border: 0;
    display: inline-block;
    padding: 0.5rem 1rem;
    margin-right: 0.5rem;
    margin-bottom: 0.5rem;
    cursor: pointer;
`;

const SaveButton = styled.button`
    background-color: #88aacc;
    color: white;
    border-radius: 0.25rem;
    border: 0;
    display: inline-block;
    padding: 0.5rem 1rem;
    margin-bottom: 0.5rem;    
    cursor: pointer;
`;

const FormatLink = styled.div`
    color: #aaaaaa;
    font-size: 0.9rem;
    display: inline-block;
    padding-left: 0.75rem;
    vertical-align: bottom;
    margin-bottom: 0.5rem;    
    cursor: pointer;
`;

const TextArea = styled.textarea`
    display: block;
    padding: 1rem;
`;

export class EditJson extends Component {

    static propTypes = {
        text: PropTypes.string.isRequired,
        save_handler: PropTypes.func.isRequired,
        cancel_handler: PropTypes.func.isRequired
    }

    state = {
        text: this.props.text
    };

    componentDidMount() {
    }

    cancel_edit() {
        this.props.cancel_handler();
    }

    save_edit() {
        const json = JSON.parse(this.state.text)
        this.props.save_handler(JSON.stringify(json, undefined, 2));
    }

    change_text(e) {
        this.setState({text: e.target.value})
    }

    format_json() {
        const json = JSON.parse(this.state.text)
        this.setState({text: JSON.stringify(json, undefined, 2)})
    }

    render() {
        const cancel_button = <CancelButton onClick={e => this.cancel_edit()}>cancel</CancelButton>
        const save_button = <SaveButton onClick={e => this.save_edit()}>save</SaveButton>
        const format_link = <FormatLink onClick={e => this.format_json()}>format</FormatLink>
        return <ContentWrapper>
            {cancel_button}
            {save_button}
            {format_link}
            <TextArea
                rows={35}
                cols={100}
                value={this.state.text}
                onChange={e => this.change_text(e)}/>
        </ContentWrapper>
    }
}

export default EditJson;

